enum FileType {
  File = 'File',
  Template = 'Template',
  BrokerTemplate = 'BrokerTemplate',
}

export default FileType;
